import { createContext, type ComponentType, type ReactNode } from 'react';
import type { Product } from '../useCheckoutForm';

/** Cadre du bloc « Avantages » (code promo, carte cadeau) fourni par la mise en page appelante. */
export interface AdvantagesFrameProps {
  /** Produit du panier, celui que reçoit le bloc Avantages (le cadre peut en déduire si la carte cadeau est proposée). */
  product: Product;
  /** Le bloc Avantages du Nouveau Panier (Advantages.tsx), tel quel : mêmes champs, mêmes appels, même état. */
  children: ReactNode;
}

/**
 * Options de mise en page du Nouveau Panier. Valeur par défaut (aucun fournisseur) = rendu historique, inchangé :
 * c'est le cas du Nouveau Panier de l'app actuelle (toggle « Activer le nouveau Panier »).
 *
 * Fournies par la nouvelle interface (src/v2/screens/Checkout, docs/ux-v2/SPEC.md § 4.7 CK1) : présentation seulement,
 * aucune logique de paiement, de code promo ni de carte cadeau ne passe par ici.
 */
export interface CheckoutLayout {
  /**
   * Présent : le bloc Avantages est rendu dans ce cadre, AU-DESSUS de « Moyen de paiement », à la place de la section
   * « Avantages » du bas du formulaire. Absent : section « Avantages » en bas du formulaire (rendu historique).
   */
  AdvantagesFrame?: ComponentType<AdvantagesFrameProps>;
}

export const CheckoutLayoutContext = createContext<CheckoutLayout>({});
